function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "40",
  height: "40",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M37.011 17.886L22.114 2.99A3.375 3.375 0 0019.727 2H5.375A3.375 3.375 0 002 5.375v14.352c0 .895.356 1.754.989 2.387L17.886 37.01a3.375 3.375 0 004.773 0l14.352-14.35a3.375 3.375 0 000-4.773zm-1.59 3.182L21.068 35.421a1.125 1.125 0 01-1.59 0L4.579 20.522a1.118 1.118 0 01-.329-.795V5.375c0-.62.505-1.125 1.125-1.125h14.352c.3 0 .583.117.796.33L35.42 19.476a1.126 1.126 0 010 1.591zm-23.296-10.35a1.408 1.408 0 010 2.812 1.406 1.406 0 010-2.811zm0-1.968a3.375 3.375 0 100 6.75 3.375 3.375 0 000-6.75z"
})));